module.exports = __webpack_public_path__ + "img/tick.f24e8b23.svg";